/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
  
  Modified by yang@onerockwell
  
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') {
    ShopifyAPI = {};
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
    if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
            attribute = '';
        }
    }
    return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
    // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/update.js',
            data: 'note=' + attributeToString(note),
            dataType: 'json',
            beforeSend: function() {
                $body.trigger('beforeUpdateCartNote.ajaxCart', note);
            },
            success: function(cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                } else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
            },
            error: function(XMLHttpRequest, textStatus) {
                $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
        alert(data.message + '(' + data.status + '): ' + data.description);
    }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
  Yang@onerockwell Added ShopifyAPI.addMultipleItems
==============================================================================*/
ShopifyAPI.addMultipleItems = function(data, callback, errorCallback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            beforeSend: function(jqxhr, settings) {
                $body.trigger('beforeAddItem.ajaxCart');
            },
            success: function(line_item) {
                if ((typeof callback) === 'function') {
                    callback(line_item);
                } else {
                    ShopifyAPI.onItemAdded(line_item);
                }
                $body.trigger('afterAddItem.ajaxCart', [line_item]);
            },
            error: function(XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus);
                } else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/add.js',
            data: jQuery(form).serialize(),
            dataType: 'json',
            beforeSend: function(jqxhr, settings) {
                $body.trigger('beforeAddItem.ajaxCart', form);
            },
            success: function(line_item) {
                if ((typeof callback) === 'function') {
                    callback(line_item, form);
                } else {
                    ShopifyAPI.onItemAdded(line_item, form);
                }
                $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
            },
            error: function(XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus);
                } else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
    $(document.body).trigger('beforeGetCart.ajaxCart');
    jQuery.getJSON('/cart.js', function(cart, textStatus) {
        if ((typeof callback) === 'function') {
            callback(cart);
        } else {
            ShopifyAPI.onCartUpdate(cart);
        }
        $(document.body).trigger('afterGetCart.ajaxCart', cart);
    });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/change.js',
            data: 'quantity=' + quantity + '&line=' + line,
            dataType: 'json',
            beforeSend: function() {
                $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
            },
            success: function(cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                } else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
            },
            error: function(XMLHttpRequest, textStatus) {
                $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};



/*============================================================================
  Product Options
==============================================================================*/
ShopifyAPI.selectCallback = function(variant, selector) {
    // var moneyFormat = Shopify.money_format;
    var moneyFormat = theme.moneyFormat;
    // Selectors
    if (selector.domIdPrefix.split('-').length > 1) {
        var selectorArray = selector.domIdPrefix.split('-');
        var $addToCart = $('#AddToCart-' + selectorArray[1]);
    } else {
        var $addToCart = $('#AddToCart');
    }

    var $productWrapper = $addToCart.parents('.product-core'), // Defined the Product Dom Scope
        $productPrice = $productWrapper.find('.product-price'),
        $comparePrice = $productWrapper.find('.product-compare-price'),
        $productJson = $productWrapper.find('[data-product-json]').length ? JSON.parse($productWrapper.find('[data-product-json]').html()) : false,
        $addToCartText = $productWrapper.find('.add-to-cart-text');

    var hasSoldOutTag = false;
    if ($productJson != false) {
        var currentTag, i, count = $productJson.tags.length
        for (i = 0; i < count; i++) {
            var currentTag = $productJson.tags[i];
            if (currentTag == "OOS") {
                hasSoldOutTag = true;
                break;
            }
        }
    }

    // Variant
    if (variant) {
        // Select a valid variant if available
        if (variant.available && hasSoldOutTag != true) {
            // Available, enable the submit button, change text, show quantity elements
            $addToCart.removeClass('disabled').prop('disabled', false);
            if ($addToCart.hasClass('pre-order')) {
                $addToCartText.html("Pre Order");
            } else {
                $addToCartText.html("Add to Cart");
            }
        } else {
            // Sold out, disable the submit button, change text, hide quantity elements
            $addToCart.addClass('disabled').prop('disabled', true);
            if (!$addToCart.hasClass('inquire')) {
                $addToCartText.html("Sold Out");
            }
        }
        // console.log('variant selected and update price');
        // console.log(selector);
        // Regardless of stock, update the product price
        $productPrice.html(Shopify.formatMoney(variant.price, moneyFormat));

        // Also update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
            $comparePrice.html(Shopify.formatMoney(variant.compare_at_price, moneyFormat)).show();
        } else {
            $comparePrice.hide();
        }

    } else {
        $addToCart.addClass('disabled').prop('disabled', true);
        if (!$addToCart.hasClass('inquire')) {
            $addToCartText.html("Sold Out");
        }
    }
};
/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

    'use strict';

    // Public functions
    var init, loadCart, freeShippingMessage;

    // Private general variables
    var settings, isUpdating, $body;
    var lastAddedItemKey, lastAddedVariantId, showOnlyLastAddedCount;

    // Private plugin variables
    var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

    // Private functions
    var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty, isMobileView, getItemsToRender, shouldShowOnlyLastAdded;

    /*============================================================================
      Initialise the plugin and define global options
    ==============================================================================*/
    init = function(options) {

        // Default settings
        settings = {
            formSelector: 'form[action^="/cart/add"]',
            cartContainer: '#CartContainer',
            addToCartSelector: 'input[type="submit"]',
            cartCountSelector: null,
            cartCostSelector: null,
            moneyFormat: '$',
            disableAjaxCart: false,
            enableQtySelectors: true,
            showLastItemOnMobile: false,
            debugLastItemOnMobile: false
        };

        // Override defaults with arguments
        $.extend(settings, options);

        // Select DOM elements
        $formContainer = $(settings.formSelector);
        $cartContainer = $(settings.cartContainer);
        $addToCart = $formContainer.find(settings.addToCartSelector);
        $cartCountSelector = $(settings.cartCountSelector);
        $cartCostSelector = $(settings.cartCostSelector);

        // General Selectors
        $body = $(document.body);

        // Track cart activity status
        isUpdating = false;
        lastAddedItemKey = null;
        lastAddedVariantId = null;
        showOnlyLastAddedCount = 0;

        // Setup ajax quantity selectors on the any template if enableQtySelectors is true
        if (settings.enableQtySelectors) {
            qtySelectors();
        }

        // Take over the add to cart form submit action if ajax enabled
        if (!settings.disableAjaxCart && $addToCart.length) {
            formOverride();
        }

        // Run this function in case we're using the quantity selector outside of the cart
        adjustCart();
    };

    loadCart = function() {
        $body.addClass('drawer--is-loading');
        ShopifyAPI.getCart(cartUpdateCallback);
    };

    updateCountPrice = function(cart) {
        if ($cartCountSelector) {
            $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

            if (cart.item_count === 0) {
                $cartCountSelector.addClass('hidden-count');
            }
        }
        if ($cartCostSelector) {
            $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
        }
    };

    formOverride = function() {
        $formContainer.on('submit', function(evt) {
            evt.preventDefault();
            var proceed = true;
            var $currForm = $(evt.target);
            var $selects = $currForm.find('select');
            $.each($selects, function(i, v) {
                if ($(v).val() == '') {
                    proceed = false;
                    return false;
                }
            });

            if (!proceed) {
                alert('Please select all options');
                return false;
            }

            // Add class to be styled if desired
            $addToCart.removeClass('is-added').addClass('is-adding');

            // Remove any previous quantity errors
            $('.qty-error').remove();

            ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
        });
    };

    itemAddedCallback = function(product) {
        $addToCart.removeClass('is-adding').addClass('is-added');
        lastAddedItemKey = product && product.key ? product.key : null;
        lastAddedVariantId = product && product.variant_id ? product.variant_id : null;
        if (settings.showLastItemOnMobile && isMobileView()) {
            // Allow two render passes: add-to-cart build + drawer load build.
            showOnlyLastAddedCount = 2;
        } else {
            showOnlyLastAddedCount = 0;
        }
        if (settings.debugLastItemOnMobile) {
            console.log('[ajaxCart] itemAddedCallback', {
                key: lastAddedItemKey,
                variantId: lastAddedVariantId,
                showOnlyLastAdded: shouldShowOnlyLastAdded(),
                showOnlyLastAddedCount: showOnlyLastAddedCount,
                isMobile: isMobileView()
            });
        }
        ShopifyAPI.getCart(function(cart) {
            cartUpdateCallback(cart);
            $body.trigger('afterAddToCart.ajaxCart', cart);
        });
    };

    itemErrorCallback = function(res, text) {
        $addToCart.removeClass('is-adding is-added');

        if (!!text) {
            if (res.status == 422) {
                $formContainer.after('<div class="errors qty-error">' + text + '</div>')
            }
        }
    };

    cartUpdateCallback = function(cart) {
        // Update quantity and price
        updateCountPrice(cart);
        buildCart(cart);
    };

    buildCart = function(cart) {
        // Start with a fresh cart div
        $cartContainer.empty();

        // Show empty cart
        if (cart.item_count === 0) {
            $cartContainer
                .append('<p class="ajaxcart__empty">' + "Your bag is currently empty." + '</p>');
            cartCallback(cart);
            return;
        }

        // Helper to check cart item property
        Handlebars.registerHelper('ifHidden', function(a, opts) {
            if (/_\w+/.test(a)) {
                return opts.fn(this);
            } else {  
                return opts.inverse(this);
            }
        });

        // Helper adds ifEqual functionality
        Handlebars.registerHelper('ifEqual', function(arg1, arg2, options) {
            return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
        });

        // Helper adds ifNotEqual functionality
        Handlebars.registerHelper('ifNotEqual', function (a, b, options) {
            if (a != b) { return options.fn(this); }
            return options.inverse(this);
        });

        // Handlebars.js cart layout
        var items = [],
            item = {},
            data = {},
            source = $("#CartTemplate").html(),
            template = Handlebars.compile(source);

        console.log(cart.items);

        if (settings.debugLastItemOnMobile) {
            console.log('[ajaxCart] buildCart start', {
                itemCount: cart.item_count,
                itemsLength: cart.items ? cart.items.length : 0,
                showOnlyLastAdded: shouldShowOnlyLastAdded(),
                showOnlyLastAddedCount: showOnlyLastAddedCount
            });
        }

        // Add each item to our handlebars.js data
        var cartItems = getItemsToRender(cart.items || []);
        if (settings.debugLastItemOnMobile) {
            console.log('[ajaxCart] buildCart renderItems', {
                renderCount: cartItems.length,
                renderKeys: $.map(cartItems, function(item) { return item.key; })
            });
        }
        $.each(cartItems, function(index, cartItem) {
            /* Hack to get product image thumbnail
             *   - If image is not null
             *     - Remove file extension, add _small, and re-add extension
             *     - Create server relative link
             *   - A hard-coded url of no-image
             */
            if (cartItem.image != null) {
                var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '');
            } else {
                var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
            }

            // Create item's data object and add to 'items' array
            item = {
                key: cartItem.key,
                line: index + 1, // Shopify uses a 1+ index in the API
                url: cartItem.url,
                img: prodImg,
                name: cartItem.product_title,
                variation: cartItem.variant_title,
                properties: cartItem.properties,
                itemAdd: cartItem.quantity + 1,
                itemMinus: cartItem.quantity - 1,
                itemQty: cartItem.quantity,
                price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
                vendor: cartItem.vendor,
                linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
                originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
                discounts: cartItem.discounts,
                discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
                isGiftCard: cartItem.gift_card,
                productId: cartItem.product_id
            };

            var $activeQb = $('.quick-buy-container.active');
            if($activeQb.length){
                var $activeQbId = $activeQb.data('id');
                var $qtyInput = $activeQb.find('.qty-input');
                var qtyNum = $activeQb.find('.ajaxcart__qty-num');
                var minusQty = $activeQb.find('.qty-btn.minus');
                var plusQty = $activeQb.find('.qty-btn.plus');

                if(item.productId == $activeQbId){
                    minusQty.attr('data-line', item.line);
                    minusQty.attr('data-qty', item.itemMinus);

                    qtyNum.attr('data-line', item.line);
                    qtyNum.attr('value', (item.itemQty));
                    qtyNum.attr('prev-value', (item.itemQty));

                    plusQty.attr('data-line', item.line);
                    plusQty.attr('data-qty', item.itemAdd);
                
                    $qtyInput.text(item.itemQty);
                }
            }

            items.push(item);
        });

        // Gather all cart data and add to DOM
        data = {
            items: items,
            note: cart.note,
            totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
            totalCartDiscount: cart.total_discount === 0 ? 0 : "\u003cp\u003eYou're saving\u003c\/p\u003e".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
            totalCartDiscountApplied: cart.total_discount === 0 ? false : true
        }

        $cartContainer.append(template(data));
        if (showOnlyLastAddedCount > 0) {
            showOnlyLastAddedCount -= 1;
        }
        if (settings.debugLastItemOnMobile) {
            console.log('[ajaxCart] buildCart end', {
                showOnlyLastAdded: shouldShowOnlyLastAdded(),
                showOnlyLastAddedCount: showOnlyLastAddedCount
            });
        }

        cartCallback(cart);

        freeShippingMessage(cart);
    };

    isMobileView = function() {
        if (window.ORW && ORW.responsive) {
            return ORW.responsive === 'small';
        }
        if (window.matchMedia) {
            return window.matchMedia('(max-width: 767px)').matches;
        }
        return false;
    };

    shouldShowOnlyLastAdded = function() {
        return showOnlyLastAddedCount > 0;
    };

    getItemsToRender = function(cartItems) {
        if (!shouldShowOnlyLastAdded()) {
            return cartItems;
        }

        var filtered = [];
        if (lastAddedItemKey) {
            filtered = $.grep(cartItems, function(item) {
                return item.key === lastAddedItemKey;
            });
        } else if (lastAddedVariantId) {
            filtered = $.grep(cartItems, function(item) {
                return item.variant_id === lastAddedVariantId;
            });
        }

        if (!filtered.length) {
            filtered = cartItems.slice(-1);
        }

        if (settings.debugLastItemOnMobile) {
            console.log('[ajaxCart] getItemsToRender', {
                showOnlyLastAdded: shouldShowOnlyLastAdded(),
                showOnlyLastAddedCount: showOnlyLastAddedCount,
                lastAddedItemKey: lastAddedItemKey,
                lastAddedVariantId: lastAddedVariantId,
                cartKeys: $.map(cartItems, function(item) { return item.key; }),
                filteredKeys: $.map(filtered, function(item) { return item.key; })
            });
        }

        return filtered;
    };

    freeShippingMessage = function(cart) {
        // Dynamic Free Shipping Message
        var $freeSuccess = $('body').find('.free-shipping-countdown__success');
        var $freeRemaining = $('body').find('.free-shipping-countdown__remaining');
        var free_threshold = '40';
        var free_threshold_price = parseFloat(free_threshold) * 100;
        var $progress = $freeRemaining.find('.free-shipping-countdown__pointer');
     
    
        if (cart.total_price >= free_threshold_price) {
            $freeSuccess.show();
            $freeRemaining.hide();
        } else {
            var remaining = free_threshold_price - cart.total_price;
            $freeSuccess.hide();
            $freeRemaining.find('span').text(`$${remaining / 100}`);
            $progress.css('width', `${cart.total_price/free_threshold}%`);
            var progressWidth = `${cart.total_price/free_threshold}`;
            if (progressWidth > 98){
                $progress.css({
                    'border-top-right-radius': '8px',
                    'border-bottom-right-radius': '8px',
                });
            }
            $freeRemaining.show();
        }

    };

    cartCallback = function(cart) {
        $body.removeClass('drawer--is-loading');
        $body.trigger('afterCartLoad.ajaxCart', cart);

        if (window.Shopify && Shopify.StorefrontExpressButtons) {
            Shopify.StorefrontExpressButtons.initialize();
        }
    };

    adjustCart = function() {
        // Delegate all events because elements reload with the cart

        // Add or remove from the quantity
        $body.on('click', '.ajaxcart__qty-adjust', function() {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                $qtySelector = $el.siblings('.ajaxcart__qty-num'),
                qty = parseInt($qtySelector.val().replace(/\D/g, '')),
                qtyEvent = '';

            var qty = validateQty(qty);

            // Add or subtract from the current quantity
            if ($el.hasClass('ajaxcart__qty--plus')) {
                qty += 1;
                qtyEvent = "add_to_cart"
            } else {
                qty -= 1;
                if (qty <= 0) qty = 0;
                qtyEvent = "subtract_from_cart"
            }

            // If it has a data-line, update the cart.
            // Otherwise, just update the input's number
            if (line) {
                $body.trigger('changeCartItemQty.ajaxCart', [line, qtyEvent]);
                updateQuantity(line, qty);
            } else {
                $qtySelector.val(qty);
            }
        });

        $body.on('click', '.ajaxcart__qty-remove', function(e) {
            e.preventDefault();
            var $el = $(this),
                line = $el.data('line');
            qtyEvent = "remove_from_cart";

            if (isUpdating) {
                return;
            }
            $body.trigger('changeCartItemQty.ajaxCart', [line, qtyEvent]);
            updateQuantity(line, 0);
        });

        // Update quantity based on input on change
        $body.on('change', '.ajaxcart__qty-num', function() {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                form = $(this).closest('form'),
                qtyPrev = parseInt($el.attr('prev-value').replace(/\D/g, '')),
                qty = parseInt($el.val().replace(/\D/g, '')),
                qtyNew = 0,
                qtyEvent = '';

            var qty = validateQty(qty);

            // Add or subtract from the current quantity
            if (qty > qtyPrev) {
                qtyNew = qty - qtyPrev;
                qtyEvent = "add_to_cart"
            } else {
                if (qty <= 0) qty = 0;
                if (qty > 0) qtyNew = qtyPrev - qty;
                qtyEvent = "subtract_from_cart"
            }

            // If it has a data-line, update the cart
            if (line) {
                $body.trigger('changeCartItemQty.ajaxCart', [line, qtyEvent, form, qtyNew]);
                updateQuantity(line, qty);
            }
        });

        // Prevent cart from being submitted while quantities are changing
        $body.on('submit', 'form.ajaxcart', function(evt) {
            if (isUpdating) {
                evt.preventDefault();
            }
        });

        // Highlight the text when focused
        $body.on('focus', '.ajaxcart__qty-adjust', function() {
            var $el = $(this);
            setTimeout(function() {
                $el.select();
            }, 50);
        });

        function updateQuantity(line, qty) {
            isUpdating = true;

            // Add activity classes when changing cart quantities
            var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

            if (qty === 0) {
                $row.parent().addClass('is-removed');
            }

            // Slight delay to make sure removed animation is done
            setTimeout(function() {
                ShopifyAPI.changeItem(line, qty, adjustCartCallback);
            }, 250);
        }

        // Save note anytime it's changed
        $body.on('change', 'textarea[name="note"]', function() {
            var newNote = $(this).val();

            // Update the cart note in case they don't click update/checkout
            ShopifyAPI.updateCartNote(newNote, function(cart) {});
        });
    };

    adjustCartCallback = function(cart) {
        // Update quantity and price
        updateCountPrice(cart);

        // Reprint cart on short timeout so you don't see the content being removed
        setTimeout(function() {
            isUpdating = false;
            ShopifyAPI.getCart(buildCart);
        }, 150)
    };

    createQtySelectors = function() {
        // If there is a normal quantity number field in the ajax cart, replace it with our version
        if ($('input[type="number"]', $cartContainer).length) {
            $('input[type="number"]', $cartContainer).each(function() {
                var $el = $(this),
                    currentQty = $el.val();

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source = $("#AjaxQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });
        }
    };

    qtySelectors = function() {
        // Change number inputs to JS ones, similar to ajax cart but without API integration.
        // Make sure to add the existing name and id to the new input element
        var numInputs = $('input.enable-qty-selector');

        if (numInputs.length) {
            numInputs.each(function() {
                var $el = $(this),
                    currentQty = $el.val(),
                    inputName = $el.attr('name'),
                    inputId = $el.attr('id');

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source = $("#JsQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus,
                        inputName: inputName,
                        inputId: inputId
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });

            // Setup listeners to add/subtract from the input
            $('.js-qty__adjust').on('click', function() {
                var $el = $(this),
                    line = $el.closest('.product-info').data('line'),
                    form = $el.closest('form'),
                    $qtySelector = $el.siblings('.js-qty__num'),
                    qty = parseInt($qtySelector.val().replace(/\D/g, '')),
                    qtyPrev = parseInt($el.siblings('.js-qty__num').attr('prev-value').replace(/\D/g, '')),
                    qtyNew = 0,
                    qtyEvent = '';

                var qty = validateQty(qty);

                // Add or subtract from the current quantity
                if (qty > qtyPrev || $el.hasClass('js-qty__adjust--plus')) {
                    if (qty == qtyPrev) {
                        qtyNew = 1;
                        qty += qtyNew;
                    } else {
                        qtyNew = qty - qtyPrev;
                        // qty = qty + qtyNew;
                    }
                    qtyEvent = "add_to_cart"
                } else {
                    if (qty <= 0) qty = 0;
                    if (qty > 0) {
                        if (qty == qtyPrev) {
                            qtyNew = 1;
                            qty -= qtyNew;
                        } else {
                            qtyNew = qtyPrev - qty;
                            // qty = qty - qtyNew;
                        }
                    } 
                    qtyEvent = "subtract_from_cart"
                }

                // Update the input's number
                $body.trigger('changeCartItemQty.ajaxCart', [line, qtyEvent, form, qtyNew]);
                $qtySelector.val(qty);
            });

            $('.js-qty__num').on('keyup', function(e) {
                if (e.key === 'Enter' || e.keyCode === 13) {
                        var $el = $(this),
                        line = $el.closest('.product-info').data('line'),
                        form = $el.closest('form'),
                        qty = parseInt($el.val().replace(/\D/g, '')),
                        qtyPrev = parseInt($el.attr('prev-value').replace(/\D/g, '')),
                        qtyNew = 0,
                        qtyEvent = '';

                    var qty = validateQty(qty);

                    // Add or subtract from the current quantity
                    if (qty > qtyPrev) {
                        qtyNew = qty - qtyPrev;
                        qtyEvent = "add_to_cart"
                    } else {
                        if (qty <= 0) qty = 0;
                        if (qty > 0) qtyNew = qtyPrev - qty;
                        qtyEvent = "subtract_from_cart"
                    }

                    // Update the input's number
                    $body.trigger('changeCartItemQty.ajaxCart', [line, qtyEvent, form, qtyNew]);
                }
            });
        }
    };

    validateQty = function(qty) {
        if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
            // We have a valid number!
        } else {
            // Not a number. Default to 1.
            qty = 1;
        }
        return qty;
    };

    module = {
        init: init,
        load: loadCart,
        freeShippingMessage: freeShippingMessage
    };

    return module;

}(ajaxCart || {}, jQuery));